import React from 'react';
import './YandexAuth.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const YandexAuth: React.FC = () => {
  const handleYandexLogin = async () => {
    console.log('🔵 Yandex login button clicked');

    try {
      console.log('🔵 Fetching Yandex auth URL from API...');
      const response = await fetch(`${API_URL}/auth/oauth/yandex/url`);
      console.log('🔵 Response status:', response.status);

      const data = await response.json();
      console.log('🔵 Response data:', data);

      if (!response.ok) {
        throw new Error(data.error || 'Ошибка получения URL авторизации');
      }

      // Перенаправляем пользователя на страницу авторизации Yandex
      window.location.href = data.url;
    } catch (error) {
      console.error('❌ Error initiating Yandex login:', error);
      alert('Ошибка при попытке авторизации через Яндекс: ' + (error as Error).message);
    }
  };

  return (
    <button
      onClick={handleYandexLogin}
      className="yandex-login-button"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M11.5 0C5.149 0 0 5.149 0 11.5S5.149 23 11.5 23 23 17.851 23 11.5 17.851 0 11.5 0zm4.5 17.5h-3v-11h-2l4-5 4 5h-3v11z"/>
      </svg>
      Войти через Яндекс
    </button>
  );
};

export default YandexAuth;
